'use client'
export const dynamic = "force-dynamic";

import axios from 'axios'
import React, { useEffect, useState } from 'react'
import Image from "next/image"

const bandcampImageEndpoint = "https://f4.bcbits.com/img/"

export default function BandcampSupporters() {
  const [fetching, setFetching] = useState(false);
  const [fetched, setFetched] = useState(false);
  const [error, setError] = useState(false);
  const [supporters, setSupporters] = useState<{name: string; image_id: string;}[]>([]);

  const askBandcampVeryNicely = async () => {
    if(fetched || fetching) return;
    setFetching(true);
    axios.post('/api/bandcamp-supporters')
      .then((bc) => {
        setSupporters(bc.data.list);

        setFetching(false);
        setFetched(true);
      })
      .catch((err) => {
        setError(true);
        console.log(err)
      })
  }

  if(error) (
    <div className='flex gap-2 items-center'>
      <div>
        <i className='bx bxs-error'></i>
      </div>
      <p className='text-xs'>couldn't fetch bandcamp supporters</p>
    </div>
  )

  useEffect(() => {
    askBandcampVeryNicely();
  }, [askBandcampVeryNicely]);

  if(!fetched) return (
    <div className='flex gap-2 items-center'>
      <div>
        <i className='bx bx-loader animate-spin'></i>
      </div>
      <p className='text-xs'>asking bandcamp nicely</p>
    </div>
  )

  console.log(supporters)

  return (
    <div className='space-y-4'>
      <div className='flex justify-center gap-2 bg-[#61929c] rounded-lg'>
       <Image
         src="/assets/logos/bandcamp.png"
         width={120}
         height={20}
         alt="Bandcamp"
         style={{
           maxWidth: "100%",
           height: "auto"
         }} />
     </div>
      <div className='grid auto-cols-max grid-cols-2 sm:grid-cols-4 gap-2'>
        {
          supporters.map((s) => (
            <div className='text-neutral-200' key={s.name}>
              <div key={s.name} className='flex gap-2 text-xs items-center'>
                <Image
                  src={bandcampImageEndpoint + s.image_id + "_42.jpg"}
                  height={32}
                  width={32}
                  alt="Profile picture"
                  style={{
                    maxWidth: "100%",
                    height: "auto"
                  }}></Image>
                {s.name}
              </div>
            </div>
          ))
        }
      </div>
    </div>
  );
}
